import React from "react";
import {useRegionTypesQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";
import { GraphQlSelectId } from "./GraphQlSelectId";

export const RegionTypeSelect = (props) => {
    const query = useRegionTypesQueryQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="name" />:<GraphQlSelect queryResult={query} {...props}  labelField="name" />;
}

